import * as THREE from 'three';
import Application from '../Application';
// @ts-ignore
import fragmentShader from '../Shaders/coffee/fragment.glsl';
// @ts-ignore
import vertexShader from '../Shaders/coffee/vertex.glsl';
export default class CoffeeSteam {
    constructor() {
        this.application = new Application();
        this.resources = this.application.resources;
        this.scene = this.application.scene;
        this.time = this.application.time;
        this.boostUntil = 0;
        this.boostAmount = 0;
        this.setModel();
    }
    setModel() {
        this.model = {};
        this.model.color = '#c9c9c9';
        // Material
        this.model.material = new THREE.ShaderMaterial({
            transparent: true,
            depthWrite: false,
            vertexShader,
            fragmentShader,
            uniforms: {
                uTime: { value: 0 },
                uTimeFrequency: { value: 0.001 },
                uUvFrequency: { value: new THREE.Vector2(3, 5) },
                uColor: { value: new THREE.Color(this.model.color) },
            },
        });
        this.model.mesh = new THREE.Mesh(new THREE.PlaneGeometry(280, 700), this.model.material);
        this.model.mesh.position.copy(new THREE.Vector3(1670, 200, 900));
        this.scene.add(this.model.mesh);
    }
    /**
     * "Refill" the mug: steam grows taller and moves faster for a moment.
     */
    boost(duration = 2600) {
        this.boostUntil = Date.now() + duration;
    }
    update() {
        this.model.material.uniforms.uTime.value = this.time.elapsed;
        const target = Date.now() < this.boostUntil ? 1 : 0;
        this.boostAmount += (target - this.boostAmount) * 0.06;
        const b = this.boostAmount;
        this.model.mesh.scale.set(1 + 0.3 * b, 1 + 0.6 * b, 1);
        this.model.mesh.position.y = 200 + 210 * b;
        this.model.material.uniforms.uTimeFrequency.value = 0.001 + 0.0015 * b;
    }
}
